import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { GiWeightLiftingUp } from "react-icons/gi";
import "./NotFound.css";

export default function NotFound() {
  return (
    <>
      <Helmet>
        <title>Page Not Found | Firm Fit Factory</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <section className="not-found">
        <span className="not-found__ghost" aria-hidden="true">404</span>
        <div className="container not-found__content">
          <GiWeightLiftingUp className="not-found__icon" aria-hidden="true" />
          <span className="eyebrow" style={{ justifyContent: "center" }}>Set Down, Not Failed</span>
          <h1>This Rep Doesn't Exist</h1>
          <p>The page you're looking for has been moved or never existed. Let's get you back on track.</p>
          <div className="not-found__actions">
            <Link to="/" className="btn btn-primary">Back to Home</Link>
            <Link to="/contact" className="btn btn-outline">Contact Us</Link>
          </div>
        </div>
      </section>
    </>
  );
}
